var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 12,
    fill: "#E7EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9286 20.1851L21.7313 14.6587C21.907 14.4034 22 14.1463 22 13.9325C22 13.5193 21.6667 13.2637 21.1087 13.2637L12.89 13.2637C12.3327 13.2637 12 13.519 12 13.9312C12 14.1453 12.0931 14.3984 12.2693 14.6541L16.0719 20.1832C16.3168 20.5388 16.6465 20.7357 17.0004 20.7357C17.3542 20.7358 17.6837 20.5411 17.9286 20.1851Z",
    fill: "#4D7CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdownIcon.3852e5eda750d21f476657f20733d631.svg";
export { ForwardRef as ReactComponent };